// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-doc-template-js": () => import("/src/src/templates/docTemplate.js" /* webpackChunkName: "component---src-templates-doc-template-js" */),
  "component---src-pages-404-js": () => import("/src/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-en-js": () => import("/src/src/pages/index.en.js" /* webpackChunkName: "component---src-pages-index-en-js" */),
  "component---src-pages-index-js": () => import("/src/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-index-ru-js": () => import("/src/src/pages/index.ru.js" /* webpackChunkName: "component---src-pages-index-ru-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/src/.cache/data.json")

